import { FindIdCompletePanel } from "@/components/panel/FindIdCompletePanel";
import { FindIdPanel } from "@/components/panel/FindIdPanel";
import { FindPasswordPanel } from "@/components/panel/FindPasswordPanel";
import { H4 } from "@/components/typography/H4";
import { FindIdAndPasswordTab } from "@/types/payload/find-id-and-password-tab";
import { Tabs } from "flowbite-react";
import { useState } from "react";

export default function FindIdAndPasswordPage() {
  const [activeTab, setActiveTab] = useState(FindIdAndPasswordTab.ID);
  const [findPartnerEmail, setFindPartnerEmail] = useState("");

  const updateFindPartnerEmail = (email: string) => {
    setFindPartnerEmail(email);
  };

  const clearFindPartnerEmail = () => {
    setFindPartnerEmail("");
  };

  const updateActiveTab = (tabType: FindIdAndPasswordTab) => {
    setActiveTab(tabType);
  };

  const handleTabChange = (tabIndex: number) => {
    if (tabIndex === 0) {
      setActiveTab(FindIdAndPasswordTab.ID);
    } else {
      setActiveTab(FindIdAndPasswordTab.PASSWORD);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      {findPartnerEmail ? (
        <FindIdCompletePanel
          findPartnerEmail={findPartnerEmail}
          clearFindPartnerEmail={clearFindPartnerEmail}
          updateActiveTab={updateActiveTab}
        />
      ) : (
        <div className="flex flex-col items-center w-[400px]">
          <H4 className="text-semantic-text-heading mb-[20px]">
            아이디/비밀번호 찾기
          </H4>
          <Tabs
            className="w-full"
            variant="underline"
            onActiveTabChange={handleTabChange}
          >
            <Tabs.Item title="아이디 찾기" active={activeTab.isId()} />
            <Tabs.Item title="비밀번호 찾기" active={activeTab.isPassword()} />
          </Tabs>
          {activeTab.isId() && (
            <FindIdPanel updateFindPartnerEmail={updateFindPartnerEmail} />
          )}
          {activeTab.isPassword() && <FindPasswordPanel />}
        </div>
      )}
    </div>
  );
}
